import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { reaction } from 'mobx'
import i18n from 'i18next'
import uuidv4 from 'uuid/v4'
import { cloneDeep } from 'lodash'
import * as R from 'ramda'
import Select from 'react-select'
import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'

import '../distribute.scss'

const deviceOptions = {
    desktop: false,
    tablet: false,
    phone: false,
}

const browserOptions = {
    chrome: false,
    safari: false,
    firefox: false,
    ie: false,
}

@observer
class InterceptLogicModal extends Component {
    labels = {
        OR: i18n.t('distributionInterceptModal.operator.or'),
        AND: i18n.t('distributionInterceptModal.operator.and'),
        CENTER: i18n.t('distributionInterceptModal.operator.center'),
        LOWER_RIGHT: i18n.t('distributionInterceptModal.operator.lowerRight'),
        LOWER_LEFT: i18n.t('distributionInterceptModal.operator.lowerLeft'),
    }

    options = [
        {
            title: i18n.t('distributionInterceptModal.options.lastOffered'),
            type: 'lastOfferedRule',
            label: i18n.t('distributionInterceptModal.options.enterNum'),
        },
        {
            title: i18n.t('distributionInterceptModal.options.percentChange'),
            type: 'percentRule',
            label: i18n.t('distributionInterceptModal.options.enterPc'),
        },
        {
            title: i18n.t('distributionInterceptModal.options.noOfVisits'),
            type: 'siteVisitsRule',
            label: i18n.t('distributionInterceptModal.options.enterNum'),
        },
        {
            title: i18n.t('distributionInterceptModal.options.pagesVisited'),
            type: 'pagesVisitedRule',
            label: i18n.t('distributionInterceptModal.options.enterPath'),
        },
        {
            title: i18n.t('distributionInterceptModal.options.timeOnPage'),
            type: 'timeOnPageRule',
            label: i18n.t('distributionInterceptModal.options.enterNum'),
        },
        {
            title: i18n.t('distributionInterceptModal.options.timeOnSite'),
            type: 'timeOnSiteRule',
            label: i18n.t('distributionInterceptModal.options.enterNum'),
        },
        {
            title: i18n.t('distributionInterceptModal.options.browser'),
            type: 'browserRule',
        },
        {
            title: i18n.t('distributionInterceptModal.options.device'),
            type: 'deviceRule',
        },
    ]

    constructor(props) {
        super(props)
        this.locationOptions = [
            {
                label: this.labels.CENTER,
                value: 'c',
            },
            {
                label: this.labels.LOWER_RIGHT,
                value: 'lr',
            },
            {
                label: this.labels.LOWER_LEFT,
                value: 'll',
            },
        ]

        this.state = this.initState()
    }

    componentDidMount() {
        this.disposeReaction = reaction(
            // eslint-disable-next-line react/destructuring-assignment
            () => this.props.distributeStore.showInterceptRulesModal, // need direct access
            (show) => {
                if (show) {
                    this.setState({ loading: true }, () => this.getInterceptRules())
                }
            },
        )
    }

    componentWillUnmount() {
        this.disposeReaction?.()
    }

    initState = () => ({
        selectedSkipGroup: 0,
        loading: false,
        ipList: '',
        excludeList: '',
        width: {
            value: '992',
            postfix: 'px',
        },
        height: {
            value: '90',
            postfix: 'vh',
        },
        scale: 1,
        location: this.locationOptions[0],
        skipGroups: [
            {
                id: uuidv4(),
                rules: [],
            },
        ],
    })

    mobileDefaults = (state) => {
        const mobileState = cloneDeep(state)
        mobileState.width = {
            value: 450,
            postfix: 'px',
        }
        mobileState.height = {
            value: 500,
            postfix: 'px',
        }
        return mobileState
    }

    logicOptions = () => {
        const { selectedSkipGroup, skipGroups } = this.state
        const usedOptions = skipGroups[selectedSkipGroup].rules.map((r) => r.type)

        return this.options
            .filter((r) => !usedOptions.includes(r.type))
            .map((o) => (
                <div
                    data-ruletype={`${o.type}`}
                    onClick={this.addRule}
                    style={{ cursor: 'pointer', margin: '5px 0px' }}
                >
                    <i className="fal fa-plus" style={{ color: '#61d5b6', marginRight: '10px' }} />
                    {o.title}
                </div>
            ))
    }

    addRule = (e) => {
        const ruleType = e.currentTarget.getAttribute('data-ruletype')
        const state = cloneDeep(this.state)
        let value = ''
        if (ruleType === 'deviceRule') {
            value = {
                desktop: false,
                tablet: false,
                phone: false,
            }
        } else if (ruleType === 'browserRule') {
            value = {
                chrome: false,
                safari: false,
                firefox: false,
                ie: false,
            }
        }
        state.skipGroups[state.selectedSkipGroup].rules.push({
            id: uuidv4(),
            type: ruleType,
            value,
            operator: { value: this.labels.OR, label: this.labels.OR },
        })
        e.preventDefault()
        this.setState(state)
    }

    addGroup = () => {
        const state = cloneDeep(this.state)
        state.selectedSkipGroup += 1
        state.skipGroups.push({
            id: uuidv4(),
            rules: [],
            operator: { value: this.labels.AND, label: this.labels.AND },
        })
        this.setState(state)
    }

    changeRuleValue = (e) => {
        const ruleIndex = Number(e.target.getAttribute('data-ruleindex'))
        const groupIndex = Number(e.target.getAttribute('data-groupindex'))
        const state = cloneDeep(this.state)
        const { skipGroups } = state
        const skipGroup = skipGroups[groupIndex]
        const rule = skipGroup.rules[ruleIndex]
        rule.value = e.target.value
        this.setState({
            skipGroups,
        })
    }

    changeRuleChecked = (e) => {
        e.stopPropagation()
        const ruleIndex = Number(e.currentTarget.getAttribute('data-ruleindex'))
        const groupIndex = Number(e.currentTarget.getAttribute('data-groupindex'))
        const ruleType = e.currentTarget.getAttribute('data-type')
        const state = cloneDeep(this.state)
        const { skipGroups } = state
        const skipGroup = skipGroups[groupIndex]
        const rule = skipGroup.rules[ruleIndex]
        rule.value[ruleType] = !rule.value[ruleType]
        this.setState({
            skipGroups,
        })
    }

    getInterceptRules = async () => {
        const { store, distributeStore } = this.props
        const { survey } = store
        const state = this.initState()
        try {
            const response = await store.http.get(
                `/survey/${survey.id}/campaign/${distributeStore.campaignUUID}/intercept`,
                store.surveyToken,
            )
            const rules = JSON.parse(response.rules)
            const settings = JSON.parse(response.settings)

            state.ipList = response.ipList
            state.excludeList = response.excludeList || ''
            state.scale = settings.scale

            state.width = settings.width
            state.height = settings.height
            state.location = this.locationOptions
                .find((lo) => lo.value === settings.location) || this.locationOptions[0]

            state.skipGroups = rules.map((r) => {
                r.operator = r.operator
                    ? {
                        value: r.operator,
                        label: r.operator,
                    } : undefined
                r.rules = r.rules.map((a) => {
                    a.operator = a.operator
                        ? {
                            value: a.operator,
                            label: a.operator,
                        } : undefined
                    if (a.type === 'deviceRule') {
                        a.value = Object.keys(deviceOptions).reduce((options, k) => {
                            options[k] = a.value.includes(k)
                            return options
                        }, {})
                    } else if (a.type === 'browserRule') {
                        a.value = Object.keys(browserOptions).reduce((options, k) => {
                            options[k] = a.value.includes(k)
                            return options
                        }, {})
                    }
                    return a
                })
                return r
            })
        } catch (e) {
            console.log(e)
        }
        this.setState(state)
    }

    ruleType = (type, value, label, ruleIndex, groupIndex) => {
        let inputs = []
        let jc = 'space-between'

        switch (type) {
            case 'percentRule':
                inputs = [{
                    type: 'number',
                    min: 1,
                    max: 100,
                    value,
                    onChange: this.changeRuleValue,
                    'data-ruleindex': ruleIndex,
                    'data-groupindex': groupIndex,
                }]
                break
            case 'siteVisitsRule':
            case 'lastOfferedRule':
            case 'timeOnPageRule':
            case 'timeOnSiteRule':
                inputs = [{
                    type: 'number',
                    min: 0,
                    value,
                    onChange: this.changeRuleValue,
                    'data-ruleindex': ruleIndex,
                    'data-groupindex': groupIndex,
                }]
                break
            case 'pagesVisitedRule':
                inputs = [{
                    type: 'text',
                    value,
                    onChange: this.changeRuleValue,
                    'data-ruleindex': ruleIndex,
                    'data-groupindex': groupIndex,
                }]
                break
            case 'browserRule':
                jc = 'flex-end'
                inputs = [
                    { name: 'chrome', label: 'Chrome', checked: value.chrome },
                    { name: 'safari', label: 'Safari', checked: value.safari },
                    { name: 'firefox', label: 'Firefox', checked: value.firefox },
                    { name: 'ie', label: 'Internet Explorer', checked: value.ie },
                ].map((browser) => ({
                    type: 'checkbox',
                    name: browser.name,
                    label: browser.label,
                    checked: browser.checked,
                    'data-type': browser.name,
                    onClick: this.changeRuleChecked,
                    'data-ruleindex': ruleIndex,
                    'data-groupindex': groupIndex,
                }))
                break
            case 'deviceRule':
                jc = 'flex-end'
                inputs = [
                    { name: 'desktop', label: i18n.t('device.desktop'), checked: value.desktop },
                    { name: 'tablet', label: i18n.t('device.tablet'), checked: value.tablet },
                    { name: 'phone', label: i18n.t('device.phone'), checked: value.phone },
                ].map((device) => ({
                    type: 'checkbox',
                    name: device.name,
                    label: device.label,
                    checked: device.checked,
                    'data-type': device.name,
                    onClick: this.changeRuleChecked,
                    'data-ruleindex': ruleIndex,
                    'data-groupindex': groupIndex,
                }))
                break
            default:
                inputs = []
        }

        return (
            <div style={{ fontWeight: 400, display: 'flex', justifyContent: jc, alignItems: 'center' }}>
                {label}
                {inputs.map((config, i) => {
                    if (config.type === 'checkbox') {
                        return (
                            <label 
                                key={config.name || i}
                                onClick={(e) => e.stopPropagation()}
                                style={{fontWeight: 400, marginRight: '8px', marginTop: '8px'}}
                            >
                                <input
                                    type={config.type}
                                    data-type={config['data-type']}
                                    onClick={config.onClick}
                                    data-ruleindex={config['data-ruleindex']}
                                    data-groupindex={config['data-groupindex']}
                                    checked={config.checked}
                                />
                                {' '}
                                {config.label}
                            </label>
                        )
                    }
                    return (
                        <input
                            key={i}
                            type={config.type}
                            min={config.min}
                            max={config.max}
                            value={config.value}
                            onChange={config.onChange}
                            data-ruleindex={config['data-ruleindex']}
                            data-groupindex={config['data-groupindex']}
                        />
                    )
                })}
            </div>
        )
    }

    changeRuleOperator = (ruleIndex, groupIndex, obj) => {
        const state = cloneDeep(this.state)
        const { skipGroups } = state
        const skipGroup = skipGroups[groupIndex]
        const rule = skipGroup.rules[ruleIndex]
        rule.operator = obj
        this.setState({
            skipGroups,
        })
    }

    removeRule = (ruleIndex, groupIndex) => {
        const state = cloneDeep(this.state)
        const { skipGroups } = state
        const skipGroup = skipGroups[groupIndex]
        skipGroup.rules.splice(ruleIndex, 1)
        this.setState({
            skipGroups,
        })
    }

    ruleOperator = (sr, index, groupIndex) => (
        index > 0
            ? (
                <Select
                    classNamePrefix="ddPrefix"
                    className="defaultDropdown"
                    value={sr.operator}
                    onChange={(obj) => this.changeRuleOperator(index, groupIndex, obj)}
                    options={[
                        {
                            value: this.labels.OR,
                            label: this.labels.OR,
                        },
                        {
                            value: this.labels.AND,
                            label: this.labels.AND,
                        },
                    ]}
                />
            )
            : null
    )

    skipRule = (sr, index, groupIndex) => {
        const option = this.options.find((o) => o.type === sr.type)
        return (
            <Fragment>
                {this.ruleOperator(sr, index, groupIndex)}
                <div
                    key={sr.id}
                    className="skipRule"
                    style={{
                        background: '#FFF',
                        padding: '10px',
                        borderRadius: '5px',
                        color: '#353a3d',
                        margin: '5px 0px',
                    }}
                >
                    <div style={{ fontWeight: 600 }} onClick={() => this.removeRule(index, groupIndex)}>
                        <i className="fal fa-times-circle" style={{ color: 'red' }} />
                        {' '}
                        {option.title}
                    </div>
                    {this.ruleType(sr.type, sr.value, option.label, index, groupIndex)}
                </div>
            </Fragment>
        )
    }

    selectGroup = (index) => {
        const { selectedSkipGroup } = this.state
        if (selectedSkipGroup !== index) {
            this.setState({
                selectedSkipGroup: index,
            })
        }
    }

    changeGroupOperator = (index, obj) => {
        const state = cloneDeep(this.state)
        const { skipGroups } = state
        const skipGroup = skipGroups[index]
        skipGroup.operator = obj
        this.setState({
            skipGroups,
        })
    }

    groupOperator = (sg, index) => (
        index > 0
            ? (
                <div>{this.labels.OR}</div>
            )
            : null
    )

    removeGroup = (e) => {
        e.preventDefault()
        e.stopPropagation()
        const index = Number(e.currentTarget.getAttribute('data-index'))
        const state = cloneDeep(this.state)
        const skipGroups = state.skipGroups.filter((sg, i) => i !== index)
        let { selectedSkipGroup } = state
        if (selectedSkipGroup >= index && index > 0) {
            selectedSkipGroup = index - 1
        }
        if (skipGroups.length === 0) {
            skipGroups.push({
                id: uuidv4(),
                rules: [],
            })
        }
        this.setState({
            skipGroups,
            selectedSkipGroup,
        })
    }

    skipGroup = (sg, index) => (
        <Fragment>
            {this.groupOperator(sg, index)}
            <div
                key={sg.id}
                data-index={index}
                style={{ marginBottom: '1em', position: 'relative' }}
                onClick={() => this.selectGroup(index)}
                className={`skip_group ${this.state.selectedSkipGroup === index ? 'selected' : ''}`}
            >
                <i
                    data-index={index}
                    className="remove_skip fal fa-times-circle deleteicon right"
                    onClick={this.removeGroup}
                />
                {sg.rules.map((sr, i) => this.skipRule(sr, i, index))}
            </div>
        </Fragment>
    )

    getOffset = (el) => {
        let _x = 0
        let _y = 0
        while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
            _x += el.offsetLeft - el.scrollLeft
            _y += el.offsetTop - el.scrollTop
            el = el.offsetParent
        }
        return { top: _y, left: _x }
    }

    save = async () => {
        const { distributeStore, store } = this.props
        const { survey } = store
        const {
            skipGroups, scale, location, width, height, ipList, excludeList,
        } = this.state
        const ruleMap = (r) => {
            const rule = {
                id: r.id,
                type: r.type,
                operator: r.operator.value,
                value: r.value,
            }

            if (['browserRule', 'deviceRule'].includes(r.type)) {
                rule.value = Object.keys(r.value).filter((k) => r.value[k])
            }
            return rule
        }
        const logic = skipGroups.reduce((l, sg) => {
            l.push({
                id: sg.id,
                operator: R.pathOr(undefined, ['operator', 'value'], sg),
                rules: R.map(ruleMap, sg.rules),
            })
            return l
        }, [])
        // console.log(JSON.stringify(logic, null, 4))
        const settings = {
            location: location.value,
            scale: Number(scale).toFixed(2),
            width,
            height,
        }
        try {
            // console.log(JSON.stringify({ settings, rules: logic, ipList }, null, 4))
            await store.http.post(
                `/survey/${survey.id}/campaign/${distributeStore.campaignUUID}/intercept`,
                JSON.stringify({
                    rules: logic,
                    ipList,
                    excludeList,
                    settings,
                }),
                store.surveyToken,
            )
            store.addNotification({ body: i18n.t('distributionInterceptModal.notification.success'), level: 'success' })
        } catch (e) {
            console.log(e)
            store.handleError({ body: i18n.t('distributionInterceptModal.notification.error'), level: 'error' })
        }
        distributeStore.closeInterceptRulesModal()
    }

    changeIpList = (e) => {
        this.setState({
            ipList: e.target.value,
        })
    }

    changeExcludeList = (e) => {
        this.setState({
            excludeList: e.target.value,
        })
    }

    changeLocation = (obj) => {
        const { location } = this.state
        let state = cloneDeep(this.state)
        if (obj.value !== 'c' && location.value === 'c') {
            state = this.mobileDefaults(state)
        }
        state.location = obj
        this.setState(state)
    }

    changeWidth = (e) => {
        const { width: currWidth } = this.state
        const { value } = e.target
        const width = cloneDeep(currWidth)
        width.value = value
        this.setState({ width })
    }

    changeWidthType = (e) => {
        const { value } = e.target
        const { width: currWidth } = this.state
        const width = cloneDeep(currWidth)
        width.postfix = value
        this.setState({ width })
    }

    changeHeight = (e) => {
        const { value } = e.target
        const { height: currHeight } = this.state
        const height = cloneDeep(currHeight)
        height.value = value
        this.setState({ height })
    }

    changeHeightType = (e) => {
        const { value } = e.target
        const { height: currHeight } = this.state
        const height = cloneDeep(currHeight)
        height.postfix = value
        this.setState({ height })
    }

    changeScale = (e) => {
        const { value } = e.target
        this.setState({ scale: value })
    }

    afterRender = () => {
        // const { top } = this.getOffset(document.getElementById('leftSkip'))
        const windowHeight = window.innerHeight
        const maxHeight = windowHeight * 0.85 - top - 100
        document.getElementById('leftSkip').style.maxHeight = `${maxHeight}px`
        document.getElementById('leftSkip').style.overflowY = 'auto'
        document.getElementById('rightSkip').style.maxHeight = `${maxHeight}px`
        document.getElementById('rightSkip').style.overflowY = 'auto'
    }

    render() {
        const { distributeStore } = this.props
        const { showInterceptRulesModal, closeInterceptRulesModal } = distributeStore
        const {
            location, width, height, skipGroups, ipList, scale, excludeList,
        } = this.state
        return (
            <Modal
                id="interceptModal"
                cssClass="large"
                show={showInterceptRulesModal}
                onClose={closeInterceptRulesModal}
            >
                <div className="uc-modal__header">
                    <Typography type="h2">{i18n.t('distributionInterceptModal.title')}</Typography>
                    <br />
                </div>

                <div className="intercept-body">
                    <div className="row">
                        <label>
                            {i18n.t('distributionInterceptModal.label.ipField')}
                        </label>
                        <input style={{ flex: 1 }} onChange={this.changeIpList} type="text" value={ipList} />
                    </div>
                    <div className="row">
                        <label>
                            {i18n.t('distributionInterceptModal.label.excluded')}
                        </label>
                        <input style={{ flex: 1 }} onChange={this.changeExcludeList} type="text" value={excludeList} />
                    </div>
                    <div className="row">
                        <label>
                            {i18n.t('distributionInterceptModal.label.width')}
                        </label>
                        <input
                            onChange={this.changeWidth}
                            type="number"
                            min="0"
                            value={width.value}
                        />
                        <div className="size-label-container">
                            <label className="size-label">
                                <input
                                    type="radio"
                                    name="widthType"
                                    onChange={this.changeWidthType}
                                    value="px"
                                    checked={width.postfix === 'px'}
                                />
                                <span>px</span>
                            </label>
                            <label className="size-label">
                                <input
                                    type="radio"
                                    name="widthType"
                                    onChange={this.changeWidthType}
                                    value="vw"
                                    checked={width.postfix === 'vw'}
                                />
                                <span>%</span>
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <label>
                            {i18n.t('distributionInterceptModal.label.height')}
                        </label>
                        <input
                            onChange={this.changeHeight}
                            type="number"
                            min="0"
                            value={height.value}
                        />
                        <div className="size-label-container">
                            <label className="size-label">
                                <input
                                    type="radio"
                                    name="heightType"
                                    onChange={this.changeHeightType}
                                    value="px"
                                    checked={height.postfix === 'px'}
                                />
                                <span>px</span>
                            </label>
                            <label className="size-label">
                                <input
                                    type="radio"
                                    name="heightType"
                                    onChange={this.changeHeightType}
                                    value="vh"
                                    checked={height.postfix === 'vh'}
                                />
                                <span>%</span>
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <label>
                            {i18n.t('distributionInterceptModal.label.scale')}
                        </label>
                        <input
                            type="number"
                            min="0"
                            max="1"
                            step=".05"
                            value={scale}
                            onChange={this.changeScale}
                        />
                    </div>
                    <div className="row">
                        <label>
                            {i18n.t('distributionInterceptModal.label.location')}
                        </label>
                        <div style={{ display: 'inline-block', width: '200px' }}>
                            <Select
                                classNamePrefix="ddPrefix"
                                className="defaultDropdown"
                                value={location}
                                onChange={this.changeLocation}
                                options={this.locationOptions}
                            />
                        </div>
                    </div>
                </div>

                <div className="divider" />

                <div className="intercept-details">
                    <div id="leftSkip">
                        {this.logicOptions()}
                    </div>
                    <div
                        id="rightSkip"
                        onLoad={this.afterRender}
                    >
                        {skipGroups.map((sg, i) => this.skipGroup(sg, i))}
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="uc-modal__button-panel" style={{ justifyContent: 'start', paddingLeft: '4px' }}>
                        <Button
                            cssClass="tertiary large"
                            onClick={closeInterceptRulesModal}
                            label={i18n.t('cancel')}
                        />
                    </div>
                    <div className="uc-modal__button-panel" style={{ flex: 0 }}>
                        <Button
                            cssClass="secondary large"
                            onClick={this.addGroup}
                            label={i18n.t('distributionInterceptModal.button.addAlt')}
                            style={{ width: '180px' }}
                        />
                        <Button
                            cssClass="primary large"
                            onClick={this.save}
                            label={i18n.t('save')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default InterceptLogicModal
